import { ReactNode } from 'react';
import cn from 'classnames';
// Components
import StreamContentTabs, {
  getTabPanelId,
  StreamContentTabKey,
} from '../StreamContentTabs/StreamContentTabs';
// Styles
import styles from './StreamContentTabPanels.module.scss';

type StreamContentTabPanelsProps = {
  availableTabs: StreamContentTabKey[];
  activeTab: StreamContentTabKey;
  onTabChange: (key: StreamContentTabKey) => void;
  hideWhenSingleTab?: boolean;
  renderPanel: (key: StreamContentTabKey) => ReactNode;
};

/** The content tabs and one panel per tab, with only the active one shown. */
const StreamContentTabPanels = ({
  availableTabs,
  activeTab,
  onTabChange,
  hideWhenSingleTab,
  renderPanel,
}: StreamContentTabPanelsProps): JSX.Element => (
  <>
    <StreamContentTabs
      availableTabs={availableTabs}
      activeTab={activeTab}
      onTabChange={onTabChange}
      hideWhenSingleTab={hideWhenSingleTab}
    />

    {availableTabs.map((key) => (
      <div
        key={key}
        role="tabpanel"
        id={getTabPanelId(key)}
        aria-labelledby={`stream-tab-${key}`}
        tabIndex={-1}
        hidden={key !== activeTab}
        className={cn(styles.panel, {
          [styles.participantsPanel]: key === StreamContentTabKey.Participants,
        })}
      >
        {renderPanel(key)}
      </div>
    ))}
  </>
);

export default StreamContentTabPanels;
